// WelcomeModal - Disabled in favor of OnboardingModal
// The onboarding process is now handled via /dashboard/new route

const WelcomeModal = () => {
  return null;
};

export default WelcomeModal;
